/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import ServiceCatalogBreadcrumbs from 'domain/organization/serviceCatalog/shared/ServiceCatalogBreadcrumbs';

const CreateServiceCatalogBreadcrumbs = () => {
  return (
    <ServiceCatalogBreadcrumbs>
      <CreateBreadcrumbItem entity="Service" />
    </ServiceCatalogBreadcrumbs>
  );
};

export default CreateServiceCatalogBreadcrumbs;
